import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {UserAudit, UserLight, UserListContainer} from '../models/userLight';
import {AuthService} from '../../services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {ClientLocation, UserInvitationProperties} from '../../clients-module/models/clientLocation';
import {ObjectUpdatePayload} from '../../models/screeningInvite';
import {environment} from 'src/environments/environment';
import {FileTransferPayload} from '../../models/FileTransferPayload';
import {SimpleDataFilter} from '../../models/simpleDataFilter';
import {UserFilter} from '../models/userFilter';
import {PaginationService} from '../../shared-components-module/pagination-top/services/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  users: Array<UserLight> = [];
  userFilter: UserFilter = new UserFilter();
  usersLoaded: Subject<boolean> = new Subject<boolean>();
  totalUsersCount: number;
  loading: boolean;

  constructor(public http: HttpClient, private auth: AuthService, private toast: ToastrService, private readonly paginationService: PaginationService) {
  }

  FetchUserList(filters: UserFilter) {
    var offset = (this.paginationService.currentPage -1) * this.paginationService.pageIncrement;
    this.loading = true;
    this.http.post<UserListContainer>(environment.baseURl + `/api/user/list/${this.paginationService.pageIncrement}/${offset}`, filters).subscribe((scc: UserListContainer) => {
        this.users = scc.listResult;
        this.totalUsersCount = scc.totalRecordsCount;
        this.usersLoaded.next(true);
        this.loading = false;
      },
      (err: any) => {
        this.toast.error('There was an error fetching users list.', '', {disableTimeOut: true, closeButton: true});
        this.loading = false;
      });
  }

  public FetchUsersForClient(clientId: number) {
    console.log('s');
    this.loading = true;
    return this.http.get<UserLight[]>(environment.baseURl + `/api/user/list/client/${clientId}`).subscribe((scc: UserLight[]) => {
      this.users = scc;
      this.loading = false;
    }, (err: any) => {
      this.toast.error('There was an error fetching users list.', '', {disableTimeOut: true, closeButton: true});
      this.loading = false;
    });
  }

  ///note: this is static and should only be used for the processor audit report.. can expand the idea if necessary, but starting with limited scope
  public FetchUsersForAuditReport() {
    return this.http.get<UserAudit[]>(environment.baseURl + `/api/user/list/audit`);
  }

  ShallowFetchUsersForClient(clientId: number) {
    console.log('s');
    return this.http.get<Array<UserLight>>(environment.baseURl + `/api/user/list/client/${clientId}`);
  }

  FetchUsersForLocation(locationId: number) {
    console.log('s');
    this.loading = true;
    this.users = [];
    this.http.get<UserLight[]>(environment.baseURl + `/api/user/list/location/${locationId}`).subscribe((scc: UserLight[]) => {
      this.users = scc;
      this.loading = false;
    }, (err: any) => {
      this.toast.error('There was an error fetching users list.', '', {disableTimeOut: true, closeButton: true});
      this.loading = false;
    });
  }

  FetchUserLocations(userId: number) {
    return this.http.get<Array<ClientLocation>>(environment.baseURl + `/api/user/locations/${userId}`);
  }

  UpdateUser(user: UserLight) {
    return this.http.post(environment.baseURl + `/api/user/update`, user);
  }

  AddPropertyToUser(updates: Array<UserInvitationProperties>) {
    return this.http.post(environment.baseURl + `/api/user/locations`, updates);
  }

  RemovePropertyFromUser(updates: Array<UserInvitationProperties>) {
    return this.http.post(environment.baseURl + `/api/user/locations/remove`, updates);
  }

  CheckUserName(name: string) {
    return this.http.get(environment.baseURl + `/api/user/un/${name}`);
  }

  UploadUsersCsv(fileData: FileTransferPayload) {
    return this.http.post(environment.baseURl + '/api/user/import', fileData);
  }

  SetUserName(name: string): Observable<any> {
    return this.http.post<any>(environment.baseURl + `/api/user/un/set`, {name: name});
  }

  public ResendInvite(token: string): Observable<any> {
    return this.http.post(environment.baseURl + '/api/user/ResendUserInvitation/' + token, null);
  }
}

